import * as React from 'react';
import { useSelector } from 'react-redux';
import { N1Page } from '../../Pages/N1Page';
import { MailPage } from '../../Pages/MailPage';
import { MediaPage } from '../../Pages/MediaPage';
import { MainPage } from '../../Pages/MainPage';
import { MobileAuthPage } from '../../Pages/MobileAuthPage';
import { SuburbanPage } from '../../Pages/SuburbanPage';
import { selectPageType } from '../../selectors/pageType';
import { EPageType } from '../../types/pageType';

export const PageContainer = () => {
  const pageType = useSelector(selectPageType);

  switch (pageType) {
    // Лендинг N1
    case EPageType.N1:
      return <N1Page />;
    // Старый маркетинговый лендинг
    case EPageType.MAIL:
      return <MailPage />;
    // Новый маркетинговый лендинг
    case EPageType.MEDIA:
      return <MediaPage />;
    case EPageType.MAIN:
      return <MainPage />;
    // Загородная недвижимость
    case EPageType.SUBURBAN:
      return <SuburbanPage />;
    // Последний шаг регистрации в ios анкете
    case EPageType.APPLICATION:
      return <MobileAuthPage />;
    default:
      return null;
  }
};
